import React, { useState, useEffect } from "react";
import SlidingPane from "react-sliding-pane";
import "react-sliding-pane/dist/react-sliding-pane.css";
import { api } from "../../../utils/Api";
import { useParams } from "react-router-dom";
import ModalViewFile from "./ModalViewFile";
import ModalTaskSalary from "./ModalTaskSalary";

export default function ModalTask(props: any) {
  const [close_data, SetCloseData] = useState({
    action: "close",
  });
  const [is_open, SetIsOpen] = useState(false);
  const [id_value, SetIdValue] = useState(useParams());
  const [task_data, SetTaskData] = useState([]);
  const [save_data, SetSaveData] = useState({
    show: false,
    index: "",
    quantity: "",
  });
  const [final_data, SetFinalData] = useState({
    is_open: false,
    data: "",
  });

  const [task_salary_modal, SetTaskSalaryModal] = useState({
    is_open: false,
    data: "",
  });

  useEffect(() => {
    console.log("ModalTask close data :", close_data);
  }, []);

  useEffect(() => {
    if (props.isOpen) {
      console.log("ModalTask On Open :", props);
      SetIsOpen(props.isOpen);
      SetTaskData(props.task_data);
    }
  }, [props.isOpen]);

  async function remove_task_finished_quantity(task_id_value: any) {
    let pass_data = {
      get: {
        brand: id_value.brand_id,
        outlet: id_value.outlet_id,
      },
      post: {
        task_id: task_id_value,
      },
    };
    let data = await api("/outlet/remove_task_finished_quantity", pass_data);
    console.log("remove_task_finished_quantity response :", data);
  }

  async function quantity_quantity(task_id_value: any) {
    let pass_data = {
      get: {
        brand: id_value.brand_id,
        outlet: id_value.outlet_id,
        task_id: task_id_value,
        order_id: id_value.order_id,
      },
      post: {
        quantity: save_data.quantity,
      },
    };
    let data = await api("/outlet/update_task_finished_quantity", pass_data);
    console.log("update_task_finished_quantity response :", data);
    SetSaveData({
      show: false,
      index: "",
      quantity: "",
    });
    if (data.response.hasOwnProperty("order_services")) {
      let service_value = data.response.order_services;
      let item = close_data;
      item.action = "save";
      item.value = service_value;
      SetCloseData(item);
      SetIsOpen(false);
      console.log("close");
      props.close(close_data);
    }
  }

  return (
    <div>
      <SlidingPane
        className="some-custom-class"
        overlayClassName="some-custom-overlay-class"
        isOpen={is_open}
        title="Task"
        onRequestClose={() => {
          let item = close_data;
          item.action = "close";
          SetCloseData(item);
          SetIsOpen(false);
          console.log("close");
          props.close(close_data);
        }}
        from="right"
        width="500px"
      >
        <div className="row">
          {task_data.map((t_ele: any, t_index: any) => (
            <div className="col-12 border-bottom pb-3" key={t_index}>
              <div className="d-flex align-items-center">
                <h6 className="mb-1">{t_ele.name}</h6>
                {t_ele.hasOwnProperty("final_out") ? (
                  <button
                    className="btn btn-light-outline btn-sm ms-auto"
                    onClick={() => {
                      SetFinalData((prevValue: any) => {
                        prevValue.is_open = true;
                        prevValue.data = t_ele.final_out;
                        return { ...prevValue };
                      });
                      console.log("modal view");
                    }}
                  >
                    View Final Out
                  </button>
                ) : (
                  <p className="ms-auto">No Final Out</p>
                  // <button
                  //   className="btn btn-light-outline btn-sm ms-auto"
                  //   onClick={() => {
                  //     SetFinalData((prevValue: any) => {
                  //       prevValue.is_open = true;
                  //       prevValue.data = [];
                  //       return { ...prevValue };
                  //     });
                  //     console.log("modal view");
                  //   }}
                  // >
                  //   View Final Out
                  // </button>
                )}
              </div>
              <h6 className="mb-1 fs-6 text-primary">{t_ele.status}</h6>

              {t_ele.hasOwnProperty("editor_user") &&
                t_ele.hasOwnProperty("editor_username") ? (
                <div>
                  <div className="d-flex mb-2 mt-2">
                    <p className="mb-0 pe-1">Editor : <span className="text-dark fs-6">{t_ele.editor_user}</span></p>
                    <small>@{t_ele.editor_username}</small>
                  </div>
                </div>
              ) : null}

              {t_ele.hasOwnProperty("finished_quantity") ? (
                <div>
                  <div className="d-flex mb-2 mt-2">
                    <p className="mb-0 pe-1">
                      Finished Quantity : <span className="fs-6 text-dark">{t_ele.finished_quantity}</span>
                    </p>
                  </div>
                </div>
              ) : null}

              <div className="d-flex">
                {!t_ele.hasOwnProperty("finished_quantity") &&
                  t_ele.hasOwnProperty("final_out") ? (
                  <button
                    className="btn btn-light-outline btn-sm ms-auto"
                    onClick={() => {
                      console.log("Update quantity");
                      SetSaveData({
                        show: true,
                        index: t_index,
                        quantity: "",
                      });
                    }}
                  >
                    Update Quantity
                  </button>
                ) : // <button
                  //   className="btn btn-light-outline btn-sm"
                  //   onClick={() => {
                  //     console.log("remove finished quantity");
                  //     // remove_task_finished_quantity(t_ele.id);
                  //   }}
                  // >
                  //   Remove Quantity
                  // </button>
                  null}

                {t_ele.hasOwnProperty("finished_quantity") ? (
                  <button
                    className="btn btn-light-outline btn-sm  ms-auto"
                    onClick={() => {
                      console.log("Editors Pay");
                      SetTaskSalaryModal((prevValue: any) => {
                        prevValue.is_open = true;
                        prevValue.data = t_ele;
                        return { ...prevValue };
                      });
                    }}
                  >
                    Editors Pay
                  </button>
                ) : null}
              </div>

              {save_data.show && save_data.index == t_index ? (
                <div className="row align-items-end mt-3">
                  <div className="col-md-6">
                    <label className="form-label">Quantity / Duration</label>
                    <input
                      type="number"
                      className="form-control"
                      onChange={(e) => {
                        SetSaveData((prevValue) => {
                          prevValue.quantity = e.target.value;
                          return { ...prevValue };
                        });
                      }}
                    />
                  </div>
                  <div className="col-md-3 col-6">
                    <button
                      className="btn btn-light-outline"
                      onClick={() => {
                        SetSaveData({
                          show: false,
                          index: "",
                          quantity: "",
                        });
                      }}
                    >
                      cancel
                    </button>
                  </div>
                  <div className="col-md-3 col-6">
                    <button
                      className="btn btn-light-outline"
                      onClick={() => {
                        if (save_data.quantity != "") {
                          quantity_quantity(t_ele.id);
                        } else {
                          console.log("Fill Quantity");
                        }
                      }}
                    >
                      Ok
                    </button>
                  </div>
                </div>
              ) : null}
            </div>
          ))}
        </div>
      </SlidingPane>

      <ModalViewFile
        open={final_data.is_open}
        data={final_data.data}
        close={(data: any) => {
          SetFinalData((prevValue: any) => {
            prevValue.is_open = false;
            return { ...prevValue };
          });
          // ReworkClose(data, "rework");
        }}
      />

      <ModalTaskSalary
        open={task_salary_modal.is_open}
        data={task_salary_modal.data}
        close={(data: any) => {
          SetTaskSalaryModal((prevValue: any) => {
            prevValue.is_open = false;
            return { ...prevValue };
          });
        }}
      />
    </div>
  );
}
